import { Injectable } from '@angular/core';
import {SharedService} from "../../shared/shared.service"
import {CategoryDataService} from "./category.data.service";
import {first} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  public categories: any;

  constructor(
    public sharedService: SharedService,
    public categoryDataService: CategoryDataService,
  ) {}

  getCategories = (type: any = null) => {
    return this.categoryDataService.list({type: type})
      .pipe(first())
      .subscribe(
        data => {
          this.categories = data.data;
        });
  }

  getProductCategories = () => {
    return this.categoryDataService.list({type: 1});
  }

  getServiceCategories = () => {
    return this.categoryDataService.list({type: 2});
  }


}
